import { PanelStore } from '@app/requests/panel/panel.store';
import { SearchOperationDto } from './../model/users-model';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersApiService } from '../users-services/users-api.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { OperationsDto } from '@app/requests/model/requests-model';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { SearchStore } from './search-store';
import { AuthenticationService, CredentialsService } from '@app/login';
import { MultilevelMenuService, MultilevelNodes } from 'ng-material-multilevel-menu';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'scf-operation-search',
  templateUrl: './operation-search.component.html',
  styleUrls: ['./operation-search.component.scss'],
})
export class OperationSearchComponent implements OnInit {
  @Output() changeSearchView = new EventEmitter<boolean>();

  searchButtonDisabled: boolean = true;
  operationFound: boolean = false;
  searchOperationForm: FormGroup;
  operationsByStateList: OperationsDto[];
  status: CommonDataDTO;
  searchCriteria: SearchOperationDto;
  public keepFilter: boolean = false;

  public classAttribute: string;

  constructor(
    private formBuilder: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    private dialog: MatDialog,
    private userService: UsersApiService,
    private panelStore: PanelStore,
    private customValidators: CustomValidatorsService,
    private searchStore: SearchStore,
    private authenticationService: AuthenticationService,
    private multilevelMenuService: MultilevelMenuService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.searchOperationForm = this.formBuilder.group({
      operationNumber: ['', [this.customValidators.isOperationValid]],
      nifNie: ['', [this.customValidators.isNifOrCifValid]],
    });

    this.route.params.subscribe((params) => {
      this.keepFilter = params['keepFilter'];
    });

    if (!this.keepFilter) {
      this.searchStore.setSearchCriteria({ operation: '', nif_nie: '' });
    } else {
      //recuperar los datos del store
      this.searchCriteria = this.searchStore.getSearchCriteria();
      //si no es nulo, se ponen los datos en los campos y se busca la solicitud
      console.log('search criteria operation search: ', this.searchCriteria);

      if (this.searchCriteria) {
        this.searchOperationForm.controls.operationNumber.setValue(this.searchCriteria.operation);
        this.searchOperationForm.controls.operationNumber.markAsDirty();
        this.searchOperationForm.controls.nifNie.setValue(this.searchCriteria.nif_nie);
        this.searchOperationForm.controls.nifNie.markAsDirty();
        this.callSearchService(this.searchCriteria);
        this.searchStore.setSearchCriteria(null);
      }
    }

    this.searchButtonDisabled = this.searchOperationForm.pristine || this.searchOperationForm.invalid;

    this.searchOperationForm.statusChanges.subscribe(() => {
      this.searchButtonDisabled =
        (!this.searchOperationForm.controls.operationNumber.value && !this.searchOperationForm.controls.nifNie.value) ||
        this.searchOperationForm.invalid;
    });
  }

  searchOperation() {
    let numOperation = this.searchOperationForm.controls.operationNumber.value;
    let nifNie = this.searchOperationForm.controls.nifNie.value;
    if (!numOperation) {
      numOperation = '';
    }
    if (!nifNie) {
      nifNie = '';
    }

    this.callSearchService({ operation: numOperation, nif_nie: nifNie });
  }

  callSearchService(criteria: SearchOperationDto) {
    new Promise<void>((res, rej) => {
      this.userService
        .postSearchOperation(criteria)
        .toPromise()
        .then(
          (result: OperationsDto[]) => {
            this.operationsByStateList = [];
            if (result && result.length > 0) {
              this.operationsByStateList = result;
              this.operationFound = true;
            } else {
              console.log(result);
              this.showDialogError(this.translateService.instant('dialog.error.no.data.found'));
            }
            res();
          },
          (error) => {
            //mostrar dialog de error
            if (!localStorage.getItem('previusRoute').includes('/panel')) {
              this.showDialogError(error.error.message);
            }
          }
        );
    });
    let url = this.router.url.split(';');
    setTimeout(() => localStorage.setItem('pageOpenSignature', JSON.stringify({ url: url[0] })), 2000);
  }

  setState(status: string): CommonDataDTO {
    return this.panelStore.getStatusByValue(status);
  }

  keepFilterSearch() {
    console.log('keep filter');
    this.searchStore.setSearchCriteria({
      operation: this.searchOperationForm.controls.operationNumber.value,
      nif_nie: this.searchOperationForm.controls.nifNie.value,
    });
  }

  private showDialogError(error: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  numberOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.searchOperationForm.controls[inputForm].value;

    let returnBoolean = this.customValidators.numberOnly(event.which ? event.which : event.keyCode, value);
    if (value.length >= 15) {
      returnBoolean = false;
    }

    return returnBoolean;
  }
  onSearchButtonClick() {
    this.changeSearchView.emit(true);
  }
}
